<template>
    <div class="no-scroll-content">
        <!-- <crm-multi-search v-if="showMultiSearch" /> -->

        <action-bar v-if="showActionBar" class="action-bar d-theme-dark-bg">
            <template v-slot:left>
                <slot name="actionLeft"></slot>
            </template>
            <template v-slot:right>
                <slot name="actionRight"></slot>
            </template>
        </action-bar>
        <component
            :is="noScroll ? 'div' : 'vx-scroll-area'"
            remember-position
            class="crm-body"
            :style="heightStyle"
            :class="{ actionbar: showActionBar }"
            ref="scrollArea"
        >
            <div id="crm-content-wrapper" :class="wrapperClasses">
                <slot></slot>
            </div>
        </component>
    </div>
</template>

<script>
import ActionBar from './ActionBar.vue'
// import CrmMultiSearch from '@/views/crm/components/CrmMultiSearch.vue'

export default {
    name: 'crm-content',
    props: {
        noScroll: {
            type: Boolean
        },
        showMultiSearch: {
            type: Boolean,
            default: false
        },
        noPadding: {
            type: Boolean
        }
    },
    components: {
        ActionBar
    },
    data() {
        return {}
    },
    computed: {
        wrapperClasses() {
            let classList = ''
            if (this.noPadding) {
                return ''
            }
            if (!this.noScroll) {
                classList += ' h-full'
            }
            return 'xxl:p-6 p-4 ' + classList
        },
        showActionBar() {
            return !!(this.$slots.actionLeft || this.$slots.actionRight)
        },
        heightStyle() {
            var actionBarHeight = this.showActionBar ? 52 : 0
            var searchHeight = this.showMultiSearch ? 47 : 0
            return {
                height: `calc(100% - ${searchHeight + actionBarHeight}px) !important`
            }
        }
    },
    methods: {
        scrollToTop() {
            if (this.$refs.scrollArea) {
                this.$refs.scrollArea.scrollToTop()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    height: 52px;
    width: 100%;
    z-index: 1;
}
.crm-body {
    height: 100%;
}

#crm-content-wrapper {
    overflow: auto;

    /* Hide scrollbar by default */
    &::-webkit-scrollbar {
        width: 0.5em;
        background: transparent;
        opacity: 0;
        transition: all 0.2s ease-in-out;
        padding: 4px;
    }

    /* Style the scrollbar track */
    &::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Style the scrollbar thumb */
    &::-webkit-scrollbar-thumb {
        background: #aaaaaa;
        border-radius: 10px;
        height: 90px;
        width: 90px;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
    }

    /* Style the scrollbar button */
    &::-webkit-scrollbar-button {
        display: none;
    }

    &:hover {
        &::-webkit-scrollbar {
            width: 0.5em;
            max-width: 0.5em;
            opacity: 1;
            transition: all 0.2s ease-in-out;
        }
        &::-webkit-scrollbar-thumb {
            opacity: 1;
            transition: width 0.2s ease-in-out, opacity 0.2s ease-in-out;
        }
    }
}
</style>
